export default "__VITE_ASSET__BoQw83DW__"